// {% comment %} remove theme cart on search page and only use boost cart  {% endcomment %}
window.onload = function () {
  function removeBoostExtInfo() {
    let boostExtInfo = $('.capacity-stroke');

    boostExtInfo.each(function () {
      let capacityText = $(this)
        .find('.boost-ext_info:contains("Capacity")')
        .text()
        .split(':')[1];
      let cableLengthText = $(this)
        .find('.boost-ext_info:contains("Cable Length")')
        .text()
        .split(':')[1];

      // check if there is no text after "Capacity" or "Stroke"
      if ($.trim(capacityText) === '' || $.trim(cableLengthText) === '') {
        // remove the element
        $(this).remove();
      }
    });
  }

  const parentElement = document.querySelector('.boost-pfs-filter-products');

  const observer = new MutationObserver(function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        removeBoostExtInfo();
        return;
      }
    }
  });

  observer.observe(parentElement, { childList: true });
  removeBoostExtInfo();

  $('#mini-cart-desktop-info').remove();
};
